import React from 'react';
import StyleMenuThemes from './StyleMenuThemes/StyleMenuThemes';
import StyleMenuFonts from './StyleMenuFonts/StyleMenuFonts';
import StyleMenuColorVariables from './StyleMenuColorVariables/StyleMenuColorVariables';
import StyleMenuIcons from './StyleMenuIcons/StyleMenuIcons';

const SidebarStyleMenuRouter = (props) => {

    switch (props.path) {
        case 'themes': return (
            <StyleMenuThemes
                onBackButtonPress={props.onBackButtonPress}
                onThemeSelect={props.onThemeSelect}
                onColorSelect={props.onColorSelect}
                currentThemeName={props.currentThemeName}
                onEditClick={props.onEditClick}
                currentViewColor={props.currentViewColor}
                onSelectColor={props.onSelectColor}
            >

                </StyleMenuThemes>)
        case 'fonts': return (
            <StyleMenuFonts
                onBackButtonPress={props.onBackButtonPress}
                onFontSelect={props.onFontSelect}
                currentFont={props.styleSettings.fontFamily}
            >
            </StyleMenuFonts>)
        case 'colorVariables': return (
            <StyleMenuColorVariables
                onBackButtonPress={props.onColorVariablesBackButtonPress}
                onColorSelect={props.onColorSelect}
                colorSource={props.colorSource}
                containerRef={props.containerRef}
              
            >
            </StyleMenuColorVariables>)
        case 'icons': return (
            <StyleMenuIcons
                onBackButtonPress={props.onBackButtonPress}
                onIconStyleSelect={props.onIconStyleSelect}
                onCartIconStyleSelect={props.onCartIconStyleSelect}
                onSpinnerIconStyleSelect={props.onSpinnerIconStyleSelect}
                currentIconStyle={props.styleSettings.iconStyle}
                currentCartIconStyle={props.styleSettings.cartIconStyle}
                currentSpinnerIconStyle={props.styleSettings.spinnerIconStyle}
            >
               
            </StyleMenuIcons>)
        default: return props.defaultRoute();
    }
}

export default SidebarStyleMenuRouter;